export const getIsUsingUSFormat = () => {
  // this is based on system's language
  // we might need to look into geoposition to be more precise

  const lang = navigator.language;

  // In CI storybook tests, the navigator.language is not defined and will throw an error for the DateTimeFormat constructor.
  try {
    return Boolean(
      new Intl.DateTimeFormat(lang, { hour: 'numeric' }).format(0).match(/\s/)
    );
  } catch (_e) {
    return Boolean(
      new Intl.DateTimeFormat('en-US', { hour: 'numeric' })
        .format(0)
        .match(/\s/)
    );
  }
};
